// extracted by mini-css-extract-plugin
export default {"Captcha":"Captcha_Captcha__POqcj","Captcha__Message":"Captcha_Captcha__Message__P48x9"};